/* Rocket NZ – hide homepage logo-slideshow on selected collections only */
(function () {
  // Update this list if you add/remove collections you want the slideshow hidden on:
  var HIDE_HANDLES = ['machines', 'grinders', 'accessories'];

  function shouldHideOnThisPage() {
    var m = window.location.pathname.match(/^\/collections\/([^\/]+)/);
    if (!m || !m[1]) return false;
    var handle = decodeURIComponent(m[1]);
    return HIDE_HANDLES.indexOf(handle) !== -1;
  }

  function hideSlideshow() {
    if (!shouldHideOnThisPage()) return;

    // Main candidates to hide (cover different class names used by Diamonds)
    var selectors = [
      'section.logo-slideshow',
      '.logo-slideshow-section',
      '.logo-slideshow__fixed-box',
      '.logo-slideshow__container'
    ];

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.style.display = 'none';
      });
    });

    // Also try to collapse any empty wrapper to avoid leftover gap
    var el = document.querySelector('section.logo-slideshow') ||
             document.querySelector('.logo-slideshow-section');
    if (el) {
      var wrap = el.closest('section') || el.parentElement;
      if (wrap) wrap.style.display = 'none';
    }
  }

  if (document.readyState !== 'loading') {
    hideSlideshow();
  } else {
    document.addEventListener('DOMContentLoaded', hideSlideshow);
  }
})();